import React, { useState } from 'react';
import { getService } from '@Client/runner.hooks/useService';
import ICategoryDetail from '@Shared.Angular/@types/core/contracts/queryModel/category/categoryDetail';
import Modal from '@Shared.Angular/flowingly.components/Modal/Modal';

type Props = {
  parentId: string;
  closeModal: () => void;
  onSubCategoryAdded: () => void;
};

const SubCategoryAddModal = ({
  parentId,
  closeModal,
  onSubCategoryAdded
}: Props) => {
  const [categoryNameInput, setCategoryNameInput] = useState('');
  const [descriptionInput, setDescriptionInput] = useState('');
  const [categoryNameError, setCategoryNameError] = useState(false);
  const notificationService = getService('notificationService');
  const appInsightsService = getService('appInsightsService');
  const guidService = getService('guidService');
  const categoryApiService = getService('categoryApiService');

  const save = async () => {
    if (!categoryNameInput) {
      setCategoryNameError(true);
      return;
    }
    const categoryDetails = getCategoryDetails(parentId);
    try {
      appInsightsService.startEventTimer('subcategoryAdded');
      const response = await categoryApiService.addCategory(categoryDetails);
      if (response.status === 200 && response.data) {
        closeModal();
        await onSubCategoryAdded();
        notificationService.showSuccessToast('Sub Category Added Successfully');
      } else {
        notificationService.showErrorToast(
          (response as any)?.data?.errorMessage || 'Error while adding Category'
        );
      }
    } catch (err) {
      console.error(err);
      notificationService.showErrorToast('Error while adding category');
    }
  };
  const handleCategoryNameChange = (event) => {
    setCategoryNameInput(event.target.value);
    setCategoryNameError(false);
  };

  const handleDescriptionChange = (event) => {
    setDescriptionInput(event.target.value);
  };

  const getCategoryDetails = (parentId) => {
    const category: ICategoryDetail = {
      id: guidService.empty(),
      name: categoryNameInput,
      description: descriptionInput,
      parentId: parentId
    };
    return category;
  };

  return (
    <Modal
      id="add-sub-category-modal"
      title={'Add Sub Category'}
      actionButtonText="Save"
      actionButtonType="primary"
      onCancelClick={closeModal}
      onActionClick={save}
      onClose={closeModal}
    >
      <div className="input-field">
        <label>Sub Category Name *</label>
        <input
          type="text"
          value={categoryNameInput}
          onChange={handleCategoryNameChange}
          required
        ></input>
        {categoryNameError && (
          <div className="red-text">Sub category name is required</div>
        )}
      </div>
      <div className="input-field">
        <label>
          Description<span className="optional"></span>
        </label>
        <input
          type="text"
          id="sub-category-description"
          value={descriptionInput}
          onChange={handleDescriptionChange}
        ></input>
      </div>
    </Modal>
  );
};

export default SubCategoryAddModal;
